(function(){
  function money(c){try{return (c/100).toLocaleString('ro-RO',{minimumFractionDigits:2,maximumFractionDigits:2})+' lei'}catch(e){return (c/100).toFixed(2)+' lei'}}

  function refreshHeader(cart){
    document.querySelectorAll('.rx-cart__n').forEach(function(e){e.textContent=cart.item_count});
    document.querySelectorAll('.rx-cart__t').forEach(function(e){e.textContent=money(cart.total_price)});
  }

  function update(line,qty,row){
    var page=document.querySelector('.rx-cartpage');
    if(page)page.classList.add('is-busy');
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:qty})})
      .then(function(r){return r.json()})
      .then(function(cart){
        refreshHeader(cart);
        var sub=document.querySelector('.rx-cartpage__sub b');
        if(sub)sub.textContent=money(cart.total_price);
        var item=cart.items[line-1];
        if(!item||qty===0){
          if(row){row.style.opacity='0';row.style.transform='translateX(-8px)';setTimeout(function(){window.location.reload()},220)}
          else window.location.reload();
          return;
        }
        var lp=row&&row.querySelector('.rx-cartpage__line');
        if(lp){
          var lbl=lp.querySelector('.rx-cartpage__lbl');
          lp.textContent=money(item.line_price);
          if(lbl)lp.insertBefore(lbl,lp.firstChild);
        }
        if(cart.item_count===0)window.location.reload();
        if(page)page.classList.remove('is-busy');
      })
      .catch(function(){window.location.reload()});
  }

  function init(){
    var page=document.querySelector('.rx-cartpage');
    if(!page||page.dataset.rxBound)return;
    page.dataset.rxBound='1';

    var rows=page.querySelectorAll('.rx-cartpage__row');
    rows.forEach(function(row,idx){
      var line=idx+1;
      var input=row.querySelector('.rx-qty__i');
      var timer;
      row.querySelectorAll('.rx-qty__b').forEach(function(b){
        b.addEventListener('click',function(){
          var val=Math.max(0,parseInt(input.value||'1',10)+parseInt(b.dataset.d,10));
          input.value=val;
          clearTimeout(timer);
          timer=setTimeout(function(){update(line,val,row)},350);
        });
      });
      if(input){
        input.addEventListener('change',function(){
          var val=Math.max(0,parseInt(input.value||'1',10));
          input.value=val;update(line,val,row);
        });
      }
      row.style.transition='opacity .2s var(--ease),transform .2s var(--ease)';
    });

    // butonul de actualizare nu mai e necesar
    var upd=page.querySelector('[name="update"]');
    if(upd)upd.style.display='none';
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();